import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=53df7316&scoped=true&"
import script from "./DashboardHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=53df7316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53df7316",
  null
  
)

export default component.exports